export default {
  temporaryPassword: ['required'],
  password: ['required'],
  confirmPassword: [
    {
      rule: 'isEqual',
      option: {
        match: 'password',
      },
      error: 'Password confirmation should match the password',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/containers/pages/Auth/setNewPasswordSchema.js